import React from "react"

interface StatsComparisonInfoProps {
  snapshotDate: string
  statsDataLength: number
  startDate: string
  endDate: string
}

const StatsComparisonInfo: React.FC<StatsComparisonInfoProps> = ({
  snapshotDate,
  statsDataLength,
  startDate,
  endDate,
}) => {
  const getYmd = (iso: string) => (iso ? iso.slice(0, 10) : "")
  const formatYmdTR = (ymd: string) => {
    if (!ymd) {
      return "-"
    }
    const [Y, M, D] = ymd.split("-")
    return `${D}.${M}.${Y.slice(2)}`
  }

  const snapshotLabel = formatYmdTR(getYmd(snapshotDate))
  const startLabel = formatYmdTR(getYmd(startDate))
  const endLabel = formatYmdTR(getYmd(endDate))

  return (
    <div className="bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-100 rounded-lg p-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="bg-indigo-500 rounded-lg p-2">
          <span className="text-white text-lg">📊</span>
        </div>
        <h2 className="text-xl font-semibold text-indigo-900">Karşılaştırma Bilgileri</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg p-4 border border-indigo-200">
          <div className="flex items-center space-x-2 mb-2">
            <span className="text-indigo-500">📅</span>
            <p className="text-sm font-medium text-indigo-700">Karşılaştırma Tarihi</p>
          </div>
          <p className="font-semibold text-gray-900">{snapshotLabel}</p>
        </div>
        <div className="bg-white rounded-lg p-4 border border-indigo-200">
          <div className="flex items-center space-x-2 mb-2">
            <span className="text-indigo-500">⏰</span>
            <p className="text-sm font-medium text-indigo-700">Gün Sayısı</p>
          </div>
          <p className="font-semibold text-gray-900">{statsDataLength} günlük veri</p>
        </div>
        <div className="bg-white rounded-lg p-4 border border-indigo-200">
          <div className="flex items-center space-x-2 mb-2">
            <span className="text-indigo-500">📅</span>
            <p className="text-sm font-medium text-indigo-700">Tarih Aralığı</p>
          </div>
          <p className="font-semibold text-gray-900">
            {startLabel} - {endLabel}
          </p>
        </div>
      </div>
    </div>
  )
}

export default StatsComparisonInfo
